/**
 * Whether the Data step may offer fields of a composite's EXTENSION members
 * (CT-5480).
 *
 * `true`: a field the composite maps is a field the builder offers, wherever
 * it lives. The mapping is the product's statement of what the composite
 * exposes, so splitting it into a usable half and a greyed-out half made the
 * builder contradict Data Studio.
 *
 * **The engine has not caught up.** A widget is still validated against the
 * composite's PRIMARY member alone, and mapping a field does not change that:
 * on `QA Composite Entity`, whose mapping covers both members, the PRIMARY
 * field saved (`DSW000`) and the EXTENSION field was refused at `create` —
 * `DSW018 Fields [...] are not fields of the chosen entity` — measured
 * 2026-10-02. Picking one fails the save until Andrey's engine derives the
 * joins from each field's origin.
 *
 * Turning this back to `false` restores the previous behaviour: the fields
 * stay listed, in their own section, not selectable.
 */
export const ALLOW_EXTENSION_MEMBER_FIELDS = true;

export default ALLOW_EXTENSION_MEMBER_FIELDS;
